<template>
<div class="ti">
  <div>
    <el-button size="mini" type="primary text2"  @click="modals" v-if="ERP.isPermission(5003002)">添加管家</el-button>
    <!-- <el-select size="mini" v-model="value" filterable placeholder="请选择组织" class="kuan" v-if="ERP.isPermission(5003001)">
      <el-option
        key=""
        label="全部"
        value="">
      </el-option>
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.company_name"
        :value="item.id">
      </el-option>
    </el-select> -->
    <el-input size="mini" class="search" placeholder="请输入搜索名称" v-model="search" clearable></el-input>
    <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
  </div>
  <v-divider></v-divider>
  <v-simple-table :height="__TABLE_HEIGHT__">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">ID</th>
            <th class="text-left">管家名称</th>
            <th class="text-left">管家电话</th>
            <th class="text-left">管家标准</th>
            <th class="text-left">日期</th>
            <th class="text-left">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr class="text1" v-for="item in desserts" :key="item.id">
            <td >{{item.id}}</td>
            <td >{{item.name}}</td>
            <td >{{item.phone}}</td>
            <td >{{item.tagging}}</td>
            <td >{{item.date}}</td>
            <td class="cdj_td">
              <div style="color: #1867c0;cursor: pointer;" @click="xiugai( item.id )" v-if="ERP.isPermission(5003003)">修改</div>
              <div  style="color: red;margin-left: 5px;cursor: pointer;" @click="del( item.id )" v-if="ERP.isPermission(5003004)">删除</div>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-divider></v-divider>
    <div class="pages" v-if="desserts">
      <Page :total="total" :page-size="page" @on-change="change"  show-total />
    </div>
    <div class="zhanwu" v-else>没有数据</div>
    <Modal
        v-model="modal1"
        :ok-text="anxiu"
        width="800"
        title="编辑(不使用了,使用管家添加需要修改)"
        @on-ok="ok">
        <Scroll height="500">
          <el-form  label-width="80px" :model="dades">
            <el-form-item label="管家名称" :rules="[{required: true}]">
              <el-input v-model="dades.name"></el-input>
            </el-form-item>
            <el-form-item label="管家电话" :rules="[{required: true}]">
              <el-input v-model="dades.phone"></el-input>
              <span style="color:red">企业微信账号同步，说明（该成员登录后，登录过企业微信，登录过后这里修改登录账号不会同步，需由成员企业微信自行修改手机号，在来这里修改手机号，为求统一）</span>
            </el-form-item>
            <el-form-item label="管家标准" :rules="[{required: true}]">
              <el-input v-model="dades.tagging"></el-input>
            </el-form-item>
            <el-form-item label="管家头像" :rules="[{required: true}]">
                <el-upload
                  :action="url"
                  list-type="picture-card"
                  :before-upload="upload"
                  :on-remove="remove"
                  :on-success="success"
                  :file-list ="img">
                  <i class="el-icon-plus"></i>
                </el-upload>
            </el-form-item>

            <el-form-item label="管家角色" :rules="[{required: true}]">
              <el-select v-model="dades.butleruser_id" filterable placeholder="请选择">
                <el-option
                  v-for="item in opdade6"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="小程序" :rules="[{required: true}]">
              <el-select v-model="dades.applets_pindex_id" filterable placeholder="请选择">
                <el-option
                  v-for="item in opdade7||[]"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="管家区域" :rules="[{required: true}]">
              <el-select v-model="dades.region_id" filterable placeholder="请选择">
                <el-option
                  key="0"
                  label="全部"
                  value="0">
                </el-option>
                <el-option
                  v-for="item in opdade8"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="1级预警">
              <el-input v-model="dades.warning1" placeholder="1级预警机器人链接"></el-input>
            </el-form-item>
            <el-form-item label="2级预警">
              <el-input v-model="dades.warning2" placeholder="2级预警机器人链接"></el-input>
            </el-form-item>
            <el-form-item label="3级预警">
              <el-input v-model="dades.warning3" placeholder="3级预警机器人链接"></el-input>
            </el-form-item>
          </el-form>
        </Scroll>
    </Modal>
</div>

</template>

<script>
export default {
  name: 'UserButler',
  data () {
    return {
      url:'',
      url1:'',
      img:[],
      defaultcheckedkeys:[],
      defaultcheckedkeyssa:[],
      dades: {
        id:'',
        name:'',
        phone:'',
        tagging: '',
        company_id: '',
        pindex_id:'',
        img:'',
        butleruser_id:'',
        applets_pindex_id:'',
        region_id:'',
        warning1:'',
        warning2:'',
        warning3:'',
      },
       options: [
        {
          value: '',
          label: ''
        },],
        options1: [
        {
          value: '',
          label: ''
        },],
      opdadeval:[
        {
          valid:'',
        },
        {
          valid:'',
        },
        {
          valid:'',
        },
        {
          valid:'',
        },
        {
          valid:'',
        },
        {
          valid:'',
        }
      ],
      opdade:[
        [{
          id:0,
          jname:'0',
        }],
        [{
          id:0,
          jname:'0',
        }],
        [{
          id:0,
          jname:'0',
        }],
        [{
          id:0,
          jname:'0',
        }],
        [{
          id:0,
          jname:'0',
        }],
        [{
          id:0,
          jname:'0',
        }]
      ],
      opdade7:[],
      opdade6:[],
      options2:[],
      value: '',
      value1:'',
      input1: '',
      desserts: '',
      cs:'',
      total:0,
      page:12,
      search:'',
      anxiu:'保存',
      modal1: false,
      opdade8:[],
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){
    this.url = this.$myhttp.defaults.baseURL + "/admin/posts";
    this.url1 = this.$myhttp.defaults.baseURL;
    var t = Date.parse(new Date()) / 1000;//时间戳
    var login = window.localStorage.getItem('login');
    ERP.showLoading()
    this.$Loading.start();
    this.$myhttp.get('admin/getcompanygshu?login='+login,{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        // this.value1 = backdata.data[0];//开启不查全部
        this.value1 = 0;
        this.$myhttp.get('admin/userButler?id=1'+'&company='+this.value +'&company1='+this.value1+'&t='+t+"&distinguish=0",{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.desserts = backdata.data[0];
            this.total = backdata.data[1];
            this.page = backdata.data[2];
            this.$Loading.finish();
          ERP.hideLoading()
        });
    });
    //加载公司列表和归属列表
    this.$myhttp.get('admin/getcompany',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        this.options = backdata.data[0];
        this.options1 = backdata.data[1];
    });
    this.$myhttp.get('admin/getuserOwners',{
    'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
      this.opdade6=backdata.data[0];
      this.opdade7=backdata.data[1];
      this.opdade8=backdata.data[2];
      this.$forceUpdate();
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
// 图片上传
    //点击上传
    upload(file){
      if(this.dades.img){
        this.$Message.error('头像只能上传一张');
        return false;
      }
    },
    //移除
    remove(file, fileList){
      this.dades.img = '';
    },
    //上传成功
    success(response, file, fileList){
      var img = this.url1+'/storage/'+file.response;
      this.img = [{name:'头像',url:img}];
      this.dades.img = '/storage/'+file.response;
      console.log(this.dades.img)
    },

// 图片上传结束

    //监听选择组织改变归属
    changesa(e){
       console.log(e);
      this.$myhttp.get('admin/getJlistOps?id='+e,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
        this.opdade[0]=backdata.data[0];
        var bc = backdata.data[0];
        this.$forceUpdate();
        this.$myhttp.get('admin/sxjm',{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.opdade[0] = bc;
            this.opdadeval[0].valid="";
            this.opdade[1] = [{id:'',jname:'',}];
            this.opdade[2] = [{id:'',jname:'',}];
            this.opdade[3] = [{id:'',jname:'',}];
            this.opdade[4] = [{id:'',jname:'',}];
            this.opdade[5] = [{id:'',jname:'',}];
          });
      });

    },
    //监听选择归属改变
    changes(e,op){
      // console.log(e);//id
      // console.log(op);//属于哪一个数组
      var ops = op+1;
      // console.log(ops);
      this.$myhttp.get('admin/getJlistOp?id='+e,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
        if(backdata.data[1] == 200){
          this.opdadeval[ops]['valid'] = '';
          if(ops == 1){
            this.opdade[1] = [{id:'',jname:'',}];
            this.opdade[2] = [{id:'',jname:'',}];
            this.opdade[3] = [{id:'',jname:'',}];
            this.opdade[4] = [{id:'',jname:'',}];
            this.opdade[5] = [{id:'',jname:'',}];
          }
          if(ops == 2){
            this.opdade[2] = [{id:'',jname:'',}];
            this.opdade[3] = [{id:'',jname:'',}];
            this.opdade[4] = [{id:'',jname:'',}];
            this.opdade[5] = [{id:'',jname:'',}];
          }
          if(ops == 3){
            this.opdade[3] = [{id:'',jname:'',}];
            this.opdade[4] = [{id:'',jname:'',}];
            this.opdade[5] = [{id:'',jname:'',}];
          }
          if(ops == 4){
            this.opdade[4] = [{id:'',jname:'',}];
            this.opdade[5] = [{id:'',jname:'',}];
          }
          if(ops == 5){
            this.opdade[5] = [{id:'',jname:'',}];
          }
          this.opdade[ops] = backdata.data[0];
        }else{
          this.opdadeval[ops]['valid'] = '';
          if(ops == 1){
            this.opdade[1] = [{id:'',jname:'',}];
            this.opdade[2] = [{id:'',jname:'',}];
            this.opdade[3] = [{id:'',jname:'',}];
            this.opdade[4] = [{id:'',jname:'',}];
            this.opdade[5] = [{id:'',jname:'',}];
          }
          if(ops == 2){
            this.opdade[2] = [{id:'',jname:'',}];
            this.opdade[3] = [{id:'',jname:'',}];
            this.opdade[4] = [{id:'',jname:'',}];
            this.opdade[5] = [{id:'',jname:'',}];
          }
          if(ops == 3){
            this.opdade[3] = [{id:'',jname:'',}];
            this.opdade[4] = [{id:'',jname:'',}];
            this.opdade[5] = [{id:'',jname:'',}];
          }
          if(ops == 4){
            this.opdade[4] = [{id:'',jname:'',}];
            this.opdade[5] = [{id:'',jname:'',}];
          }
          if(ops == 5){
            this.opdade[5] = [{id:'',jname:'',}];
          }
       }
      //  console.log(this.opdadeval);
       this.$forceUpdate();
      });
    },
    //保存
    ok(){
      if(this.dades.name == ""){
        this.$Message.error('管家名称不能为空!');
        return false;
      }
      if(this.dades.phone == ""){
        this.$Message.error('管家电话不能为空!');
        return false;
      }
      if(this.dades.tagging == ""){
        this.$Message.error('管家标准不能为空!');
        return false;
      }
      if(this.dades.img == ""){
        this.$Message.error('头像不能为空!');
        return false;
      }
      if(this.dades.company_id == ""){
        this.$Message.error('所属组织不能为空!');
        return false;
      }
      if(this.opdadeval[0].valid == ""){
        this.$Message.error('归属架构不能为空!');
        return false;
      }
      if(this.dades.butleruser_id == ""){
        this.$Message.error('管家角色不能为空!');
        return false;
      }
      if(this.dades.applets_pindex_id == ""){
        this.$Message.error('小程序不能为空!');
        return false;
      }
      if(this.dades.region_id == ""){
        this.$Message.error('管家区域不能为空!');
        return false;
      }
      var date = [this.dades,this.opdadeval]
      this.$Loading.start();
      this.$myhttp.post('admin/userButlerAdd',date,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data[0] == 1){
            this.$myhttp.get('admin/userButler?search='+ this.search + '&id=1'+'&company='+this.value +'&company1='+this.value1,{
              'Content-Type': 'application/json'
              }).then(backdata=>{ // 异步执行成功后
                this.desserts = backdata.data[0];
                this.total = backdata.data[1];
                this.page = backdata.data[2];
            });
            this.$Message.success(backdata.data[1]);
            this.dades={
              id:'',
              name:'',
              phone:'',
              tagging: '',
              company_id: '',
              pindex_id:'',
              img:'',
              butleruser_id:'',
              applets_pindex_id:'',
              region_id:'',
              warning1:'',
              warning2:'',
              warning3:'',
            };
            this.img = [];
          }else{
            this.$Message.error('编辑失败!');
          }
          this.$Loading.finish();
      });
    },
    //弹窗添加
    modals(){
      this.anxiu = "保存";
      if(this.dades.id){
        this.dades={
          id:'',
          name:'',
          phone:'',
          tagging: '',
          company_id: '',
          pindex_id:'',
          img:'',
          butleruser_id:'',
          applets_pindex_id:'',
          region_id:'',
          warning1:'',
          warning2:'',
          warning3:'',
        };
        this.img = [];
      }
      //加载公司权限列表
       this.$Loading.start();
      var login = window.localStorage.getItem('login');
      this.$myhttp.get('admin/getJlist?login='+login,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data[1] == 2){
              this.data =  backdata.data[0];
          }
          this.cs = backdata.data[1];
          this.dades.company_id=backdata.data[3];
          this.$Loading.finish();
      });
      this.$myhttp.get('admin/getuserOwners',{
      'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
        this.opdade6=backdata.data[0];
        this.opdade7=backdata.data[1];
        this.opdade8=backdata.data[2];
        this.$forceUpdate();
      });
      this.$myhttp.get('admin/getJlistssa?login='+login,{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.opdade[0] = backdata.data[0];
            this.modal1 = true;
      });
      // this.modal1 = true;
    },
    //获得当前多少页,分页
    change(e){
      ERP.showLoading()
      this.$Loading.start();
      var t = Date.parse(new Date()) / 1000;//时间戳
      this.$myhttp.get('admin/userButler?id='+ e + '&search='+ this.search +'&company='+this.value +'&company1='+this.value1+'&t='+t+"&distinguish=0",{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
        ERP.hideLoading()
      });
    },
    //搜索
    searchs(){
      ERP.showLoading()
      this.$Loading.start();
      this.$myhttp.get('admin/userButler?search='+ this.search + '&id=1'+'&company='+this.value +'&company1='+this.value1,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
        ERP.hideLoading()
      });
    },
    //修改查询
    xiugai(e){
      this.$Loading.start();
      this.anxiu="修改";
      this.$myhttp.get('admin/userButlerUpdate?id='+e,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.dades = backdata.data[0][0];
          this.cs = backdata.data[1];
          this.opdade[0] = backdata.data[2];
          this.opdadeval[0].valid = backdata.data[0][0].jurisdiction_id;
          var img = this.url1+backdata.data[0][0]['img'];
          this.dades.company_id = backdata.data[0][0].company_id;
          this.dades.region_id = backdata.data[0][0].region_id;
          this.dades.warning1 = backdata.data[0][0].warning1;
          this.dades.warning2 = backdata.data[0][0].warning2;
          this.dades.warning3 = backdata.data[0][0].warning3;
          this.img = [{name:'头像',url:img}];
          this.$Loading.finish();
          this.$forceUpdate();
          this.modal1 = true;
      });
    },
    //删除
    del(e){
      this.$confirm('此操作将永久删除该权限吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$Loading.start();
          this.$myhttp.post('admin/userButlerDelete',{id:e},{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              if(backdata.data == 200){
                this.dela = true;
                var t = Date.parse(new Date()) / 1000;//时间戳
                this.$myhttp.get('admin/userButler?id=1'+'&company='+this.value +'&company1='+this.value1+'&t='+t+"&distinguish=0",{
                  'Content-Type': 'application/json'
                  }).then(backdata=>{ // 异步执行成功后
                    this.desserts = backdata.data[0];
                    this.total = backdata.data[1];
                    this.page = backdata.data[2];
                    this.$Loading.finish();
                    this.$Message.success('删除成功!');
                  });
              }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
  },
  //监听
  watch: {
     '$route' (to, from) { //监听路由是否变化
      if(to.path == "/User/Butler"){
        this.$myhttp.get('admin/getuserOwners',{
        'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
          this.opdade6=backdata.data[0];
          this.opdade7=backdata.data[1];
          this.opdade8=backdata.data[2];
          this.$forceUpdate();
        });
      }
    }
  },

}
</script>
<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(247, 243, 243);
  font-size: 20px;
  margin-top: 3%;
}
</style>
<style>
.el-upload--picture-card {
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100px;
    height: 100px;
    line-height: 100px;
    vertical-align: top;
}
.el-upload-list--picture-card .el-upload-list__item {
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100px;
    height: 100px;
    margin: 0 8px 8px 0;
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/Butler.vue